import React from "react";
import CountryForm from "./CountryForm";

export default function AddCountryPage() {
  return <CountryForm type="Add" />;
}

